<template>
  <b-card class="mb-1" body-class="p-1">
    <b-card variant="light" class="border-0 mb-0" bg-variant="light" body-class="p-0 d-flex">
      <span
        class="item-handle d-flex align-items-center bg-secondary py-2 px-3 cursor-pointer rounded"
        :class="{'mr-2': $dir.ltr, 'ml-2': $dir.rtl}"
        @click="toggleEditing"
      >
        <font-awesome-icon icon="sort" fixed-width size="lg" class="text-muted"/>
      </span>

      <b-row class="px-1 py-2 w-100">
        <b-col cols="12">
          <b-row no-gutters class="align-items-center">
            <b-col class="mb-2 mb-md-0">
              <template v-if="item.title">
                {{ item.title }}
              </template>
            </b-col>

            <b-col md="auto" class="text-center">
              <b-btn
                variant="outline-info"
                size="sm"
                class="border-0"
                @click="toggleEditing"
                :title="$t('shared.edit')"
                v-b-tooltip.hover
              >
                <font-awesome-icon :icon="editing ? 'times' : 'pen'" fixed-width class="align-middle m-1"/>
              </b-btn>

              <b-btn
                variant="outline-danger"
                size="sm"
                class="mx-1 border-0"
                @click="emitRemoveItem(item)"
                :title="$t('shared.remove')"
                v-b-tooltip.hover
              >
                <font-awesome-icon icon="trash-alt" fixed-width class="align-middle m-1"/>
              </b-btn>
            </b-col>
          </b-row>

          <template v-if="editing">
            <hr class="my-2"/>

            <b-row class="mt-2" no-gutters>
              <b-col md="6" class="px-2 mb-2">
                <b-input-group size="sm">
                  <b-input-group-prepend is-text>
                    {{ $t('shared.title') }}
                    <required-symbol/>
                  </b-input-group-prepend>

                  <b-input v-model="item.title" dir="auto" :name="$t('shared.title')" v-validate="'required'"/>
                </b-input-group>
              </b-col>

              <b-col md="6" class="px-2 mb-2">
                <b-input-group :prepend="$t('shared.url')" size="sm">
                  <b-input v-model="item.url" dir="auto" placeholder="http(s)://"/>
                </b-input-group>
              </b-col>

              <b-col md="4" class="px-2 mb-2">
                <b-input-group :prepend="$t('shared.viewData')" size="sm">
                  <b-input v-model="item.viewData" dir="auto"/>
                </b-input-group>
              </b-col>

              <b-col md="12" class="px-2 mb-2">
                <uploader
                  :label="$t('shared.image')"
                  v-model="item.image"
                />
              </b-col>

              <b-col md="12" class="px-2 mb-2">
                <b-input-group :prepend="$t('shared.description')">
                  <b-textarea :rows="3" v-model="item.description"/>
                </b-input-group>
              </b-col>

              <b-col md="auto" class="px-2">
                <b-btn size="sm" variant="danger" @click="emitRemoveItem(item)">
                  <font-awesome-icon icon="times" fixed-width class="align-middle"/>
                </b-btn>
              </b-col>
            </b-row>
          </template>
        </b-col>
      </b-row>
    </b-card>
  </b-card>
</template>

<script>
import Uploader from '@/components/shared/Uploader'

export default {
  name: 'Item',
  components: {
    Uploader
  },
  props: {
    item: {type: Object, required: true}
  },
  data () {
    return {
      editing: this.item.id < 0 ? true : false
    }
  },
  methods: {
    toggleEditing () {
      this.editing = !this.editing
    },
    emitRemoveItem () {
      this.$emit('remove', this.item)
    }
  }
}
</script>
